require('../../modules/es.reflect.construct');
var path = require('../../internals/path');

module.exports = path.Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/reflect/construct.js
// module id = 4314
// module chunks = 25